import React from 'react';
import { LOGO_URL, CHURCH } from '@/api/client';

export default function Logo({ size = 'md', showText = true, light = false }) {
  const sizes = { sm: 'w-10 h-10', md: 'w-14 h-14', lg: 'w-20 h-20', xl: 'w-28 h-28' };
  return (
    // min-w-0 lets the wordmark truncate inside flex containers (critical for <360px screens).
    <div className="flex items-center gap-2 sm:gap-3 min-w-0">
      <img
        src={LOGO_URL}
        alt="Ministry of Jesus official emblem"
        className={`${sizes[size]} rounded-full object-contain drop-shadow flex-shrink-0`}
      />
      {showText && (
        <div className="leading-tight min-w-0">
          <div className={`font-brand ${light ? 'text-white' : 'text-moj-purple-deep'} text-xl sm:text-2xl md:text-[28px] tracking-wide truncate`}>
            Ministry of Jesus
          </div>
          <div className={`text-[10px] ${light ? 'text-moj-gold' : 'text-moj-gold-deep'} font-semibold uppercase tracking-[0.25em] mt-0.5`}>
            {CHURCH.scripture}
          </div>
        </div>
      )}
    </div>
  );
}
